import Vue from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from '../gsap-bonus/ScrollTrigger';

Vue.component('project-cards-component', {
    data() {
        return {

        };
    },

    mounted() {
        this.initReveals();
    },

    methods: {
        initReveals() {
            gsap.set(['.project-card', '.project-card__overlay',
                '.project-card__image', '.project-card__button', '.project-card__content'], { clearProps: 'all' });

            ScrollTrigger.batch('.project-card', {
                start: 'top 90%',
                onEnter: (batch) => {
                    batch.forEach((item) => {
                        const overlay = item.querySelector('.project-card__overlay');
                        const image = item.querySelector('.project-card__image');
                        const button = item.querySelector('.project-card__button');
                        const content = item.querySelector('.project-card__content');

                        const revealTl = gsap.timeline({
                            onComplete: () => {
                                item.classList.add('--revealed');
                                gsap.set('.project-card__image', { clearProps: 'all' });
                            },
                        });

                        revealTl.to(overlay, {
                            duration: 1, y: '-100%', ease: 'power3.inOut',
                        }, 0);
                        revealTl.to(image, {
                            duration: 2, scale: 1, ease: 'power2.out',
                        }, 0);
                        revealTl.to(button, {
                            duration: 0.7, autoAlpha: 1, ease: 'power4.inOut',
                        }, 0.6);
                        revealTl.to(content, {
                            duration: 0.7, autoAlpha: 1, ease: 'power4.inOut',
                        }, 0.6);
                    });
                },
            });
        },
    },
});
